export default {
    nl: {
        articles: {
            article: 'Artikel',
            articles: 'Artikelen',
            quantity: 'Aantal',
        },
    },
}
